import React, { useEffect } from "react";
import axios from "axios";

const Logout = () => {
    useEffect(() => {
        const logout = async () => {
            try {
                await axios.post(
                    `${process.env.REACT_APP_BACKEND_URL}payment-portal-logout`,
                    {},
                    {
                        withCredentials: true
                    }
                );
            } catch (error) {
                console.error("Logout error:", error);
            } finally {
                localStorage.removeItem("authUser");

                localStorage.setItem(
                    "logout-event",
                    Date.now().toString()
                );

                window.location.href = "/login";
            }
        };

        logout();
    }, []);

    return null;
};

export default Logout;